import { useEffect, useState } from 'react'
import { Form, Modal, ModalHeader } from 'react-bootstrap'
import CustomCloseButton from '../../Button/CustomCloseButton'
import CustomButton from '../../Button/CustomButton'
import * as Common from '../../../utils/Common'
import api from '../../../config/AxiosInstance'
import { useLocation } from 'react-router-dom'

function ModalSeries(props) {
  const { show, handleModal, type, submitTicket, changeInput, data, loading } =
    props
  const { state } = useLocation()
  const [options, setOptions] = useState([])
  const getDataSeries = async () => {
    try {
      const res = await api.get(
        `master/stocks/show-series?warehouse_id=${state?.warehouse_id || ''}`
      )
      const { data } = res.data
      if (data.length > 0) {
        setOptions(data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  useEffect(() => {
    getDataSeries()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, state?.warehouse_id])

  return (
    <Modal
      show={show}
      onHide={handleModal}
      centered
      className="modal-series-number"
    >
      <ModalHeader closeButton>
        <Modal.Title>Create Ticket</Modal.Title>
      </ModalHeader>
      <Modal.Body>
        <h6>Select series and make sure all info are correct!</h6>
        <Form.Group className="my-4" controlId="select-series-number">
          <Form.Label>
            Series <sup>*</sup>
          </Form.Label>
          <Form.Select
            aria-label="select-series-number"
            className="custom-select"
            onChange={(e) => changeInput('series_number', e.target.value)}
          >
            <option value="">Open this select menu</option>
            {options?.map((option, index) => (
              <option value={option.name} key={`${option.name}-${index}`}>
                {option.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Modal.Footer>
          <CustomCloseButton onClick={handleModal} />
          <CustomButton
            onClick={() => submitTicket()}
            variant={
              !data.series_number || data.series_number === '' || loading
                ? 'secondary'
                : 'warning'
            }
            disabled={
              !data.series_number || data.series_number === '' || loading
            }
            text={`${loading ? 'Creating...' : 'Create'}`}
          />
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  )
}

export default ModalSeries
